import { i18n } from '@plugins/vuetify';
import router from '../router';

const state = () => ({
    display: false,
    message: 'An error.'
});

const getters = {
    getErrorsDisplay: state => {
        return state.display;
    }
};

const mutations = {
    displayErrors(state, errno) {
        const errorsList = [4403, 4404, 4410, 4401];
        if (errno) {
            if (errorsList.includes(errno)) {
                router.push('/login');
            } else {
                state.message = i18n.t(`errors.${errno}`);
                state.display = true;
            }
        }
    },
    closeErrors(state) {
        state.display = false;
    }
};

const actions = {};

export default {
    state,
    getters,
    actions,
    mutations
};
